// extracted by mini-css-extract-plugin
module.exports = {"time":"time_time__3PpEN"};